// extracted by mini-css-extract-plugin
export default {"colourOption":"GetDq3XzjT","colorSelected":"rxD85kjvWr"};